<!-- TrustBox widget - Mini Carousel -->
<div
    *appFeatureFlag="'isTrustpilotAvailable'"
    #trustbox
    class="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="539ad0ffdec7e10e686debd7"
    data-businessunit-id="6a9689d98716e8b55449b156"
    data-style-height="350px"
    data-style-width="100%"
    data-tags="identialert"
    data-stars="4,5"
    data-review-languages="en">
    <a
        href="https://uk.trustpilot.com/review/www.identi.pet"
        target="_blank"
        rel="noopener">
        Trustpilot
    </a>
</div>
<!-- End TrustBox widget -->
